import comp from "./DialogueBoxV2";
export default comp;
